/*
* Reserve study report - chart adjustment form
*/

import * as React from 'react';
import { Row, Button } from 'react-bootstrap';

import * as FormsyWrappers from '../common/formsy/componentwrappers';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';

export const ChartFormRow = ({ children, ...rest }) => {
    return (
        <Row className="chart-form-row">
            <Col xs={12}>
                {children}
            </Col>
        </Row>
    );
};

export const ChartForm = ({
    appText,
    handleAdjustmentFormInputChange,
    handleSubmitForm,
    formData,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    // TODO: CHANGE THESE TO SET THE HYPO VALUES INSTEAD

    return (
        <FormsyWrappers.FormsyVerticalForm className="chart-form-container">
            <FormsyWrappers.FormsyFormSection title={appText('adjustments')}>
                <Row className="form-row">
                    {/* Left col */}
                    <Col xs={6}>
                        <ChartFormRow>
                            <FormsyWrappers.FormsyPercentageInput
                                name="interest"
                                label={appText('interest')}
                                value={formData.interest}
                                min={0.001}
                                step={0.001}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyPercentageInput
                                name="inflation"
                                label={appText('inflation')}
                                value={formData.inflation}
                                min={0.01}
                                step={0.001}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyCurrencyInput
                                name="beginningBalance"
                                label={appText('beginning-balance')}
                                value={formData.beginningBalance}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyCurrencyInput
                                name="mrcValue"
                                label={appText('mrc-value')}
                                value={formData.mrcValue}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>
                    </Col>

                    {/* Right col */}
                    <Col xs={6}>
                        <ChartFormRow>
                            <FormsyWrappers.FormsyPercentageInput
                                name="annualIncrease"
                                label={appText('annual-increase')}
                                value={formData.annualIncrease}
                                step={0}
                                decimals={4}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyYearsInput
                                name="secondaryAdjustmentYears"
                                label={appText('secondary-adjustment-years')}
                                value={formData.years}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyPercentageInput
                                name="secondaryAnnualIncrease"
                                label={appText('secondary-annual-increase')}
                                value={formData.secondaryAnnualIncrease}
                                step={0.001}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>

                        <ChartFormRow>
                            <FormsyWrappers.FormsyCurrencyInput
                                name="specialAssessment"
                                label={appText('special-assessment')}
                                value={formData.specialAssessment}
                                onChange={(n, v) => { handleAdjustmentFormInputChange(n, v); }}
                            />
                        </ChartFormRow>
                    </Col>
                </Row>

                {/* Footer row with button */}
                <ChartFormRow>
                    <Button type="button" bsStyle="success" className="btn-auto-compute" onClick={handleSubmitForm}>{appText('auto-compute')}</Button>
                </ChartFormRow>
            </FormsyWrappers.FormsyFormSection>
        </FormsyWrappers.FormsyVerticalForm>
    );
};



// WEBPACK FOOTER //
// ./src/report/chartform.tsx